<template>
    <div class="bg_poster">

        <div class="poster_wrap" v-show="tag" ref="snapshot" id="snapshot" crossorigin="anonymous">
            <div class="bg_wrap">
                <img :src="template"  crossorigin="anonymous">
            </div>
            <div class="slogan_wrap">
                <span class="slogan">{{slogan}}</span>
            </div>
            <div class="avatar_wrap">
                <img :src="avatar" crossorigin="anonymous">
            </div>
            <div class="info_wrap">
                <span class="name">{{name}}</span>
                <span class="dept">{{dept}}</span>
            </div>


        </div>
        <div class="btn_wrap" v-show="tag">
            <span @click="toShare()">{{btn1}}</span>
<!--            <span @click="toIndex()">重新生成</span>-->
            <span @click="posterDown()">海报下载</span>
        </div>


        <div class="poster"  v-show="!tag">
            <div class="text">
                <span class="text" >长按保存海报</span>
            </div>
            <div class="img_content">
                <img class="poster_img" :src="dataURL">
            </div>
            <div class="close">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/long/reward/close.png" @click="toClose">
            </div>
        </div>

        <div class="share_choose" v-if="posterShow">
            <div class="share_wrap">
                <span @click="posterShare">海报分享</span>
<!--                <span @click="posterShare">{{btnName()}}</span>-->
                <span @click="toIndex">{{btnName()}}</span>
            </div>
        </div>

        <div class="sharing_choose" v-if="shareShow" @click="shareShow = false">
            <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/long/reward/share_it_1.png">
        </div>



    </div>
</template>

<script>
    import {getSayInfo} from "@/assets/js/api";
    import {wxShare} from "@/assets/js/api";
    import wx from "weixin-jsapi";

    import html2canvas from 'html2canvas';

    export default {
        name: "Top",
        data(){
            return{
                openid:this.$route.query.openid,
                btn1:"海报分享",
                btn2:"即刻参与",
                slogan: "",
                avatar:"",
                tag:true,
                dataURL:"",
                windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
                windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
                template:"http://ymd-lcc.oss-cn-beijing.aliyuncs.com/long/reward/poster_template.png",
                name:"",
                dept:"",
                posterShow:false,
                shareShow:false,
                link: location.href.split("#")[0],
                doctors:[],
                title: '关注10月8日全国高血压日',
                desc: "#为爱发声 #测量血压 #坚持服药",
                imgUrl:"https://umed.oss-cn-hangzhou.aliyuncs.com/say/forlove.jpg",
            }
        },
        created(){
            this.weChatShare()
        },
        methods:{
            btnName(){
                let sopenid = localStorage.getItem("openid")
                if(this.openid==sopenid){
                    return "重新生成"
                }else{
                    return "即刻参与"
                }

                // return "海报下载"

            },
            async weChatShare() {
                let _this = this;
                const url = _this.link;
                const res = await wxShare({ url });
                console.log(_this.link, "link");
                console.log(res.data.data, "wxresult");

                if (res.data.success == true) {
                    wx.config({
                        debug: false, //开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: res.data.data.appId, //必填，公众号的唯一标识
                        timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
                        nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
                        signature: res.data.data.signature, // 必填，签名
                        jsApiList: [
                            // "updateAppMessageShareData", //自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0） 新接口
                            // "updateTimelineShareData",//自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0） 老接口
                            "onMenuShareTimeline", //分享到朋友圈 老接口
                            "onMenuShareAppMessage",
                            ], // 必填，需要使用的JS接口列表
                    });

                    wx.ready(function () {
                        //分享给朋友
                        wx.onMenuShareTimeline({
                            title: _this.title,
                            desc: _this.desc,
                            link: _this.link,
                            imgUrl: _this.imgUrl,
                            success: function (res) {
                                console.log(res, "分享成功！");
                            },
                            cancel: function (res) {
                                console.log(res, "分享失败");
                            },
                        });
                        //分享到朋友圈
                        wx.onMenuShareAppMessage({
                            title: _this.title,
                            desc: _this.desc,
                            link: _this.link,
                            imgUrl: _this.imgUrl,
                            success: function (res) {
                                console.log(res, "分享成功");
                            },
                            cancel: function (res) {
                                console.log(res, "分享失败");
                            },
                        });
                    });
                }
            },
            toShare(){
                this.posterShow = true
            },
            posterDown(){//海报下载
                this.posterShow = false
                this.tag = false
                this.pageSave()
            },

            posterShare(){//海报分享
                console.log("123456")
                this.posterShow = false
                this.shareShow = true
            },

            toIndex(){
                this.$router.replace({path:"info"})
            },
            async getSayInfo(openid){
                const res = await getSayInfo({openid})
                if(res.data.success){
                    this.slogan = res.data.data.slogan;
                    this.avatar = res.data.data.poster;
                    this.name = res.data.data.name
                    this.dept = res.data.data.dept
                }
            },
            toClose(){
                this.tag = true
                this.dataURL=""
            },
            pageSave(){
                console.log("pageS",this.windowWidth,this.windowHeight)
                //创建一个新的canvas
                let canvas2 = document.createElement("canvas");
                //获取宽高
                let w =  this.windowWidth;
                let h =  this.windowHeight;
                if(this.windowWidth>=500){
                    w = 500
                }
                h = h*0.85;//屏幕占百分之九十
                console.log("pageW",w,h)
                // // 将canvas画布放大若干倍，然后盛放在较小的容器内，就显得不模糊了
                canvas2.width = w * 2;
                canvas2.height = h * 2;
                canvas2.style.width = w + "px";
                canvas2.style.height = h + "px";

                // //可以按照自己的需求，对context的参数修改,translate指的是偏移量
                var context = canvas2.getContext("2d");
                // context.translate(-75,-130);
                // context.scale(1.85, 1.78);
                context.scale(2, 2);

                html2canvas(document.querySelector('#snapshot'),{
                    allowTaint:false,
                    useCORS:true,
                    background: "#ffffff", // 一定要添加背景颜色，否则出来的图片，背景全部都是透明的
                    scale:1,
                    width:w,
                    height:h,
                    canvas:canvas2,
                    dpi: window.devicePixelRatio * 2, // window.devicePixelRatio是设备像素比
                }).then(canvas => {
                    let imgUrl = canvas.toDataURL('image/png');
                    this.dataURL = imgUrl;
                    this.tag = false;
                    // this.share = true
                })

            },
        },
        mounted() {
            this.getSayInfo(this.openid)
        }
    }
</script>

<style scoped lang="scss">
    .bg_poster{
        width: 100%;
        height: 100vh;
        background: #FFF;
        position: relative;
    }

    .bg_wrap{
        position: absolute;
        width: 100%;
        height: 100%;
        img{
            width: 100%;
            height: 100%;
        }
    }

    .poster_wrap{
        height: 90%;
        /*background: transparent url("https://umed.oss-cn-hangzhou.aliyuncs.com/say/poster_template.png") no-repeat;*/
        /*background-size: 100% 100%;*/
        position: relative;

        .slogan_wrap{
            font-size: 14px;
            color: #0a4179;
            position: absolute;
            top: 14%;
            left: 14%;

            width:22%;
            word-wrap:break-word;
            text-align: left;
            font-weight: bold;
            text-indent: 20%;
        }
        .avatar_wrap{
            img{
                position: absolute;
                right: 8%;
                bottom: 33%;
                height: 50%;
                width: 50%;
                object-fit: cover;
            }
        }
    }
    .btn_wrap{
        height: 10%;
        width: 100%;
        background: #FFF;
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin-bottom: 20px;
        color: #FFF;
        font-size: 14px;
        span{
            width: 45%;
            height: 20px;
            line-height: 20px;
            background: #0a4179;
            padding: 3px 0;
            border-radius: 5px;
        }
    }

    .poster{
        width: 100%;
        max-width: 500px;
        height: 100vh;
        position: absolute;
        background: #000000;
        opacity: 0.95;
        display: flex;
        align-items: center;
        z-index: 100;
        flex-direction: column;
        .close{
            width: 60px;
            height: 60px;
            margin-top: 5%;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .img_content{
            width: 70%;
            height: 70%;
            background: #FFF;
            opacity: 1;
            .poster_img{
                width: 100%;
                height: 100%;
            }
        }
        .text{
            margin: 5% 0;
            color: #FFF;
            font-weight: bold;
            font-size: 25px;
        }
    }

    .info_wrap{
        font-size: 14px;
        color: #0a4179;
        position: absolute;
        font-weight: bold;
        top: 55%;
        left: 10%;
        max-width: 30%;
        .name{
            display: block;
        }
        .dept{
            display: block;
            text-align: left;
        }

    }

    .share_choose{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        max-width: 500px;
        height: 100vh;
        background: #000000;
        opacity: 0.8;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        font-weight: bold;
        .share_wrap{
            background: #FFF;
            width: 70%;
            color: #000;
            border-radius: 5px;
            span{
                display: block;
                width: 100%;
                padding: 20px 0;
            }
            span:first-child{
                border-bottom: 1px #000 solid;
            }
        }
    }

    .sharing_choose{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        max-width: 500px;
        height: 100vh;
        background: #000000;
        opacity: 0.8;
        img{
            position: absolute;
            right: 0;
            top: 0;
            width: 60%;
        }
    }


</style>
